import React from 'react';
import Header from './Header';

function MenuRelatoriosPage({ usuario, empresaSelecionada, handleVoltar, handleSair, onSelecionarRelatorio }) {
  const cardsRelatorios = [
    { 
      nome: 'Caixa', 
      key: 'caixa',
      icon: (
        <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      )
    },
    { 
      nome: 'Resumo', 
      key: 'resumo',
      icon: (
        <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    { 
      nome: 'MobTEF Dashboard', 
      key: 'mobtef',
      icon: (
        <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      )
    },
    { 
      nome: 'MobTEF Planilha', 
      key: 'mobtef_planilha',
      icon: (
        <svg className="w-8 h-8 mb-2 text-lime-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M3 10h18" />
          <path d="M9 14h1m4 0h1" />
        </svg>
      )
    },
    { 
      nome: 'ConexãoPIX', 
      key: 'conexaopix',
      icon: (
        <svg className="w-8 h-8 mb-2 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    { 
      nome: 'XMLs', 
      key: 'xmls',
      icon: (
        <svg className="w-8 h-8 mb-2 text-pink-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-2xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">Relatórios</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            {cardsRelatorios.map(card => (
              <div
                key={card.key}
                className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                onClick={() => onSelecionarRelatorio(card.key)}
              >
                {card.icon}
                <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuRelatoriosPage; 